export default __webpack_public_path__ + "static/media/ico-key.950d4d9d.svg";